import React, { useState, useEffect } from "react";
import { IconButton, Typography, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";
import InputField from "../../components/InputField/InputField";
import Dropdown from "../../components/Dropdown/Dropdown";
import Button from "../../components/Button/Button";
import Modal from "../../components/Modal/Modal";
import formFields from "../../config/formFields.json";

import {
    StyledDialog,
    StyledDialogTitle,
    StyledDialogContent,
    HeaderContainer,
    FormContainer,
    ButtonGroup,
    IconContainer,
    LabelTypography,
    GridContainer,
} from "./AddRoleStyles";
import { useLoading } from "../../contexts/LoadingContext";
import Checkbox from "../../components/Checkbox/Checkbox";
import FormValidation from "../../components/FormValidation/FormValidation";

const AddRole = ({
    open,
    onClose,
    initialData = null,
    onSubmit
}) => {
    const isEdit = !!initialData;
    const initialFormState = {
        role_name: "",
        role_description: "",
        permissions: null,
        is_active: true
    };

    const [formData, setFormData] = useState(initialFormState);
    const [errorModal, setErrorModal] = useState(null);
    const { showLoading, hideLoading } = useLoading();

    useEffect(() => {
        if (open) {
            if (initialData) {

                setFormData({
                    role_name: initialData.role_name || "",
                    role_description: initialData.role_description || "",
                    permissions: initialData.permissions.access || null,
                    is_active: initialData.is_active ?? true,
                });
            } else {
                setFormData(initialFormState);
            }
        } else {
            setFormData(initialFormState);
        }
        setErrorModal(null);
    }, [initialData, open]);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleDropdownChange = (field) => (value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    const handleSubmit = async (e) => {
        // e.preventDefault();
        setErrorModal(null);

        try {
            showLoading();
            await onSubmit({
                ...e
            });
            setFormData(initialFormState);
        } catch (error) {
            setErrorModal({
                type: "error",
                title: "Action Failed",
                message: error.message || "Something went wrong",
            });
        } finally {
            hideLoading();
        }
    };

    const handleClose = () => {
        setFormData(initialFormState);
        setErrorModal(null);
        onClose();
    };

    const handleErrorModalClose = () => {
        setErrorModal(null);
    };

    return (
        <>
            <StyledDialog open={open} onClose={handleClose} maxWidth="md">
                <StyledDialogTitle>
                    <HeaderContainer>
                        <IconContainer>
                            <BusinessIcon />
                            <Typography variant="h6">
                                {isEdit ? "Edit Role Details" : "Add New Role"}
                            </Typography>
                        </IconContainer>
                        <IconButton onClick={handleClose} size="small">
                            <CloseIcon />
                        </IconButton>
                    </HeaderContainer>
                </StyledDialogTitle>

                <FormValidation
                    modelWidth={"60vw"}
                    open={open}
                    onClose={handleClose}
                    initialData={formData}
                    onSubmit={handleSubmit}
                    formFields={formFields.role.basic.fields}
                    title="Permission"
                    icon={BusinessIcon}
                    isEdit={isEdit}
                    moduleName="role"
                />
            </StyledDialog>

            {errorModal && (
                <Modal
                    type={errorModal.type}
                    title={errorModal.title}
                    message={errorModal.message}
                    onClose={handleErrorModalClose}
                />
            )}
        </>
    );
};

export default AddRole;
